import { type MutationPayload } from 'vuex';
import Store from '../stores/store';
import { ProfileModuleConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

const { name, action } = ProfileModuleConstant;

export default class ProfileStore implements ltFramework.IProfileStore {
	public getInitialData(): ltFramework.IProfile {
		return (Store.state as ltFramework.IStoreState).profileModule.profile;
	}

	public initialize(): Promise<void> {
		return Store.dispatch(name + '/' + action.initialize);
	}

	public listen(callback: (state: ltFramework.IProfile) => void): () => void {
		return Store.subscribe((mutation: MutationPayload, state: ltFramework.IRootState) => {
			if (mutation.type.indexOf(name + '/') !== -1) {
				callback((state as ltFramework.IStoreState).profileModule.profile);
			}
		});
	}

	public logout(): Promise<void> {
		return Store.dispatch(name + '/' + action.logout);
	}

	public updateSchregSavedSearches(
		metaName: string,
		savedSearches: ltFramework.ISchregSavedSearch[],
		successCallback: () => void,
		failCallback: () => void
	) {
		if (metaName !== 'SchregSavedSearches') {
			throw new Error('Unexpected argument to update saved search: ' + metaName);
		}
		return Store.dispatch(name + '/' + action.updateSchregSavedSearches, {
			savedSearches,
			successCallback,
			failCallback
		});
	}
}
